module.exports = __webpack_public_path__ + "img/w13-qr.3f2d95e2.jpg";